import React, { useEffect, useState } from "react";
import { LikeTrackBtn } from "./LikeTrackBtn";
import { useLikePodcastTrackMutation } from "../../api/podcastsApi";
import useClickWithAuth from "../../hooks/useClickWithAuth";
import toast from "react-hot-toast";

export function LikePodcastBtnWrapper({ release, withBgColor }) {
  const [like, setLike] = useState(release.isLiked);

  const [likePodcastTrack] = useLikePodcastTrackMutation();
  const handleClickWithAuth = useClickWithAuth();

  useEffect(() => {
    setLike(release.isLiked);
  }, [release.isLiked]);

  const handleLikePodcastTrack = async (e) => {
    e.stopPropagation();

    try {
      const isLiked = like ? null : true;

      await likePodcastTrack({
        is_liked: isLiked,
        podcast_track_id: release.id,
      }).unwrap();

      setLike(isLiked);

      if (isLiked) toast.success("Вы поставили лайк");
      else toast.success("Вы убрали лайк");
    } catch {}
  };

  return (
    <LikeTrackBtn
      onClick={handleClickWithAuth(handleLikePodcastTrack)}
      like={like}
      withBgColor={withBgColor}
    />
  );
}
